import epsClient from 'enrollment-platform/api/eps.client'
import {
  ContributionReportGenerateRequestDto,
  ContributionReportGenerateResponseDto,
  ContributionReportResponseManyDto,
  ContributionReportResponseOneDto,
} from './dtos'

export const generateContributionReport = async (
  data: ContributionReportGenerateRequestDto
): Promise<ContributionReportGenerateResponseDto> => {
  const response = await epsClient.post<ContributionReportGenerateResponseDto>(
    '/api/v1/reports/contribution/generate',
    data
  )

  return response.data
}

export const fetchContributionReport = async (
  jobId: string
): Promise<ContributionReportResponseOneDto> => {
  const response = await epsClient.get<ContributionReportResponseOneDto>(
    `/api/v1/reports/contribution/status/${jobId}`
  )
  return response.data
}

export const fetchContributionReports = async (
  clientPublicKey: string
): Promise<ContributionReportResponseManyDto> => {
  const response = await epsClient.get<ContributionReportResponseManyDto>(
    `/api/v1/reports/contribution/company/${clientPublicKey}`
  )
  return response.data
}

export const deleteContributionReport = async (
  jobId: string
): Promise<void> => {
  await epsClient.delete(`/api/v1/reports/contribution/${jobId}`)
}
